// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");

// media swiper only mobile view 

  if (window.matchMedia) {
  const mq = window.matchMedia("(min-width: 750px)");
  mq.addListener(handleWidthChange);
  handleWidthChange(mq);
}

function handleWidthChange(mq) {
  const sliderEl_div = document.querySelector('[data-main-pdp-swiper]');
  if (!sliderEl_div) return; // exit if no slider on this page

  const sliderEl = document.querySelector('[data-pdp-main-slider]');
  if (!sliderEl) return;

  const optionsAttr = sliderEl.getAttribute('data-slider-options');

  if (mq.matches) {
    // Desktop: destroy swiper if exists
    if (sliderEl_div.swiper) {
      sliderEl_div.swiper.destroy(true, true);
    }
  } else {
    // Mobile: initialize swiper if not already initialized
    if (!sliderEl_div.swiper) {
      if (optionsAttr) {
        const options = JSON.parse(optionsAttr);
        new Swiper(sliderEl_div, options);
      }
    }
  }
}


})();

let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

// If transperent
// var transperentElment = document.querySelector(".allow-transparent-header");
// var header = document.querySelector(".header-wrapper");
// var topbar = document.querySelector(".announce-main-wipper");
// if (transperentElment) {
//   header.classList.add("allow-transparent-header");
//   topbar.classList.add("allow-transparent-header");
// }

const swiper = new Swiper(".testimonial-box-wrapper", {
  loop: true,
  speed: 1000,
  navigation: {
    nextEl: ".testimonial-custom-block .swiper-button-next",
    prevEl: ".testimonial-custom-block .swiper-button-prev",
  },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
    },
    350: {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
    },
    575: {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
    },
    1200: { slidesPerView: 3, spaceBetween: 20 },
  },
});

if (document.body.clientWidth < 991) {
  const topbar_swiper = new Swiper(".announce_cover", {
    loop: true,
    autoplay: {
      delay: 2000,
    },
    speed: 1000,
    pagination: {
      el: ".announce_cover .swiper-pagination",
      type: "progressbar",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 20 },
      768: { slidesPerView: 2, spaceBetween: 30 },
      990: { slidesPerView: 3, spaceBetween: 30 },
    },
  });
}

// pack selctor pdp
const radios = document.querySelectorAll('.pack-radio');
const quantityField = document.querySelector('.quantity__input.custom-quantity-field');
const priceContainer = document.querySelector('.price__container');

const regularPriceEl = priceContainer?.querySelector('.price-item--regular');
const salePriceEl = priceContainer?.querySelector('.price-item--sale');
const comparePriceEl = priceContainer?.querySelector('s.price-item--regular');

radios.forEach(radio => {
  radio.addEventListener('change', function () {
    const { price, comparePrice } = this.dataset;
  //  console.log("change!!!!!!");
    quantityField && (quantityField.value = this.value);
    document.querySelectorAll('.option-card').forEach(card => card.classList.remove('selected'));
    this.closest('.option-card')?.classList.add('selected');

    if (regularPriceEl && salePriceEl && comparePriceEl) {
      if (comparePrice && comparePrice !== price) {
        salePriceEl.textContent = price;
        comparePriceEl.textContent = comparePrice;
        salePriceEl.parentElement.style.display = 'block';
        comparePriceEl.parentElement.style.display = 'inline';
        regularPriceEl.parentElement.style.display = 'none';
      } else {
        regularPriceEl.textContent = price;
        salePriceEl.parentElement.style.display = 'none';
        comparePriceEl.parentElement.style.display = 'none';
        regularPriceEl.parentElement.style.display = 'block';
      }
    }
  });

  if (radio.checked) {
    quantityField && (quantityField.value = radio.value);
    radio.closest('.option-card')?.classList.add('selected');
    radio.dispatchEvent(new Event('change'));
  }
}); // end

// shorting on blog page

 // Dropdown change
const sortingDropdown = document.getElementById("sorting-dropdown");

if (sortingDropdown) {
  sortingDropdown.addEventListener("change", function () {
    const selectedOption = this.value;

    // blog posts sort karva
    sortBlogPosts(selectedOption);
  });
}

// Sorting function
function sortBlogPosts(option) {
  const postsContainer = document.querySelector(".blog-articles");
  const posts = Array.from(postsContainer.querySelectorAll(".cust_sort_blog"));

  switch (option) {
    case "title-ascending":
      posts.sort((a, b) =>
        a.querySelector(".blog-post-title").textContent.localeCompare(
          b.querySelector(".blog-post-title").textContent
        )
      );
      break;

    case "title-descending":
      posts.sort((a, b) =>
        b.querySelector(".blog-post-title").textContent.localeCompare(
          a.querySelector(".blog-post-title").textContent
        )
      );
      break;

    case "created-ascending":
      posts.sort((a, b) => {
        const dateA = new Date(a.querySelector(".blog-post-date").textContent);
        const dateB = new Date(b.querySelector(".blog-post-date").textContent);
        return dateA - dateB;
      });
      break;

    case "created-descending":
      posts.sort((a, b) => {
        const dateA = new Date(a.querySelector(".blog-post-date").textContent);
        const dateB = new Date(b.querySelector(".blog-post-date").textContent);
        return dateB - dateA;
      });
      break;
    default:
      break;
  }

  // Clear & append sorted
  postsContainer.innerHTML = "";
  posts.forEach((post) => postsContainer.appendChild(post));
}

// BLOG ARTICLE DATA NAVIGATE
function smoothScroll(target) {
  var header = document.querySelector('sticky-header');
  var headerHeight = (header ? header.offsetHeight + 10 : 150);
  var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
}

var navigationLinks = document.querySelectorAll('[data-faq__categories-list-item-link-cust] a');
navigationLinks.forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    //console.log(event);
     const targetId = this.hash ? this.hash.substring(1) : null; 
    const targetElement = document.getElementById(targetId);
    //console.log(targetElement);
    if (targetElement) {
      smoothScroll(targetElement);
    }
  });
});

//header menu close icon trigger
document.querySelector('drawer-close').addEventListener('click', function() {
    let menuIcon = document.querySelector('.header__icon.header__icon--menu');
    if (menuIcon) { 
        menuIcon.click();
    }
});
// ====== faq page accordian  ======
// $(document).ready(function () {
//     document.querySelectorAll(".faq_accordion .accordion").forEach(accordion=>{
//         accordion.onclick = function() {
//             if ($(this).hasClass("is-open"))
//                 $(this).removeClass("is-open"),
//                 this.nextElementSibling.style.maxHeight = "0px";
//             else {
//                 $(".faq_accordion .accordion").removeClass("is-open"),
//                 $(".faq_accordion .accordion-content").css("max-height", "0px"),
//                 $(this).addClass("is-open");
//                 let content = this.nextElementSibling;
//                 content.style.maxHeight = content.scrollHeight + "px"
//             }
//         }
//     }
//     ),
//     document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(accordion=>{
//         accordion.onclick = function() {
//             if ($(this).hasClass("is-open"))
//                 $(this).removeClass("is-open"),
//                 this.nextElementSibling.style.maxHeight = "0px";
//             else {
//                 $(".faq-page_main_wrapper .accordion").removeClass("is-open"),
//                 $(".faq-page_main_wrapper .accordion-content").css("max-height", "0px"),
//                 $(this).addClass("is-open");
//                 let content = this.nextElementSibling;
//                 content.style.maxHeight = content.scrollHeight + "px"
//             }
//         }
//     }
//     )
// });


// subscribtion widget

document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById("selling-plan-select");
  const priceEl = document.getElementById("subscription-price");
const variantData = JSON.parse(
  document.getElementById("variant-json")?.textContent || "{}"
);
  const radios = document.querySelectorAll('input[name="purchase_option"]');
  const subscriptionBox = select?.closest('.subscription-box') || null;
  



if(subscriptionBox && variantData?.selling_plan_allocations.length <= 0 ){
      if (!subscriptionBox.classList.contains('hidden')) {
          subscriptionBox.classList.add('hidden');
        }
        document.querySelector('input[name="purchase_option"][value="one-time-purchase"]').checked = true;
  }else{
      if (subscriptionBox?.classList.contains('hidden')) {
        subscriptionBox?.classList.remove('hidden');
      }

  }

  if (!variantData?.selling_plan_allocations) return;

  const planPrices = Object.fromEntries(
    variantData.selling_plan_allocations.map(a => [a.selling_plan_id, a.price])
  );

const formatMoney = cents =>
  (cents / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + "€";
  
  const getAppSelect = (selector, cb) => {
    let tries = 0;
    const interval = setInterval(() => {
      const el = document.querySelector(selector);
      if (el || tries++ > 20) {
        clearInterval(interval);
        if (el) cb(el);
      }
    }, 100);
  };

  const updatePriceAndSync = planId => {

    const variantData = JSON.parse(
      document.getElementById("variant-json")?.textContent || "{}"
    );

      const planPrices = Object.fromEntries(
        variantData.selling_plan_allocations.map(a => [a.selling_plan_id, a.price])
      );

    priceEl.textContent = planPrices[planId] ? formatMoney(planPrices[planId]) : formatMoney(variantData.price);
    getAppSelect(".ub_subscription_spg_plan_select", el => {
      el.value = planId;
      el.dispatchEvent(new Event("change", { bubbles: true }));
    });
  };

  // --- Function to enable/disable subscription dropdown ---
  const toggleDropdown = () => {
    select.disabled = document.querySelector('input[value="one-time-purchase"]').checked;
  };

  toggleDropdown(); // initial check

  // Dropdown change
  select.addEventListener("change", () => {
    if (document.querySelector('input[value="subscription"]').checked) {
      updatePriceAndSync(select.value);
    }
  });

  // Radio change
  radios.forEach(radio => radio.addEventListener("change", () => {
    toggleDropdown(); // enable/disable dropdown
    if (radio.value === "subscription") updatePriceAndSync(select.value);
    else getAppSelect(".ub_subscription_spg_plan_select", el => { el.value = ""; el.dispatchEvent(new Event("change", { bubbles: true })); });
  }));
});

